<template>
  <div>
    <b-card title="TTE" class="op">
      <b-form @submit.prevent class="px-2">
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col cols="12">
                <b-card class="bordered-card" title="Klappenstatus">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        label="Mitralinsuffizienz"
                        label-for="op_tte_klappenstatus_mitralinsuff"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_klappenstatus_mitralinsuff
                          "
                          :options="[
                            'keine',
                            'leicht',
                            'mittel',
                            'schwer',
                            ...nichterhoben,
                          ]"
                          :disabled="readOnly"
                          placeholder="Mitralinsuffizienz"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Mitralstenose"
                        label-for="op_tte_klappenstatus_mitralstenose"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_klappenstatus_mitralstenose
                          "
                          :options="[
                            'keine',
                            'leicht',
                            'mittel',
                            'schwer',
                            ...nichterhoben,
                          ]"
                          :disabled="readOnly"
                          placeholder="Mitralstenose"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Aorteninsuffizienz"
                        label-for="op_tte_klappenstatus_aorteninsuff"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_klappenstatus_aorteninsuff
                          "
                          :options="[
                            'keine',
                            'leicht',
                            'mittel',
                            'schwer',
                            ...nichterhoben,
                          ]"
                          :disabled="readOnly"
                          placeholder="Aorteninsuffizienz"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Aortenstenose"
                        label-for="op_tte_klappenstatus_aortenstenose"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_klappenstatus_aortenstenose
                          "
                          :options="[
                            'keine',
                            'leicht',
                            'mittel',
                            'schwer',
                            ...nichterhoben,
                          ]"
                          :disabled="readOnly"
                          placeholder="Aortenstenose"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Trikuspidalklappeninsuffizienz"
                        label-for="op_tte_klappenstatus_trikuspidalklappeninsuff"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_klappenstatus_trikuspidalklappeninsuff
                          "
                          :options="[
                            'keine',
                            'leicht',
                            'mittel',
                            'schwer',
                            ...nichterhoben,
                          ]"
                          :disabled="readOnly"
                          placeholder="Trikuspidalklappeninsuffizienz"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col cols="12">
                <b-card class="bordered-card" title="Rechter Ventrikel">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        label="Gemessener Gradient über Triskuspidalklappe [mmHg]"
                        label-for="op_tte_rechter_ventrikel_gemess_gradient_ueber_trikuspidalklappe"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="
                            patientInfo.op_tte_rechter_ventrikel_gemess_gradient_ueber_trikuspidalklappe
                          "
                          :options="nichterhoben"
                          taggable
                          :disabled="readOnly"
                          placeholder=""
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="TAPSE [mm]"
                        label-for="op_tte_rechter_ventrikel_tapse"
                        label-cols-md="4"
                      >
                        <v-select
                          v-model="patientInfo.op_tte_rechter_ventrikel_tapse"
                          :options="nichterhoben"
                          taggable
                          :disabled="readOnly"
                          placeholder="TAPSE [mm]"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card title="Impella" class="op">
      <b-form @submit.prevent class="px-2">
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Op Datum"
                  label-for="op_impella_op_date"
                  label-cols-md="4"
                >
                  <b-input-group class="mb-1">
                    <b-form-input
                      id="op_impella_op_date"
                      v-model="patientInfo.op_impella_op_date"
                      type="text"
                      placeholder="DD.MM.YYYY"
                      v-mask="dateMask"
                      autocomplete="off"
                      show-decade-nav
                      :readonly="readOnly"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="date"
                        value-as-date
                        show-decade-nav
                        button-only
                        button-variant="outline-primary"
                        right
                        size="sm"
                        locale="de"
                        aria-controls="example-input"
                        :disabled="readOnly"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Op Dauer [min]"
                  label-for="op_impella_op_dauer"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_op_dauer"
                    id="op_impella_op_dauer"
                    type="number"
                    placeholder="Op Dauer [min]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Access site"
                  label-for="op_impella_access_site"
                  label-cols-md="4"
                >
                  <v-select
                    v-model="patientInfo.op_impella_access_site"
                    :options="[
                      'Femoral',
                      'Subclavia',
                      'Right',
                      'Left',
                      'Aorta',
                    ]"
                    :disabled="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="HZV [l/m]"
                  label-for="op_impella_hzv"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_hzv"
                    id="op_impella_hzv"
                    type="number"
                    placeholder="HZV [l/m]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="sPAP [mmHg]"
                  label-for="op_impella_spap"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_spap"
                    id="op_impella_spap"
                    type="number"
                    placeholder="sPAP [mmHg]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="dPAP [mmHg]"
                  label-for="op_impella_dpap"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_dpap"
                    id="op_impella_dpap"
                    type="number"
                    placeholder="dPAP [mmHg]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="HLM"
                  label-for="op_impella_hlm"
                  label-cols-md="4"
                >
                  <v-select
                    v-model="patientInfo.op_impella_hlm"
                    :options="yesno"
                    :disabled="readOnly"
                  />
                </b-form-group>
              </b-col>
              <template v-if="patientInfo.op_impella_hlm === 'ja'">
                <b-col cols="12" key="opimphlmdauer">
                  <b-form-group
                    label="HLM Dauer [m]"
                    label-for="op_impella_hlm_dauer"
                    label-cols-md="4"
                  >
                    <b-form-input
                      v-model="patientInfo.op_impella_hlm_dauer"
                      id="op_impella_hlm_dauer"
                      type="number"
                      placeholder="HLM Dauer [m]"
                      :readonly="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" key="opimpxclamp">
                  <b-form-group
                    label="Xclamp"
                    label-for="op_impella_hlm_xclamp"
                    label-cols-md="4"
                  >
                    <v-select
                      v-model="patientInfo.op_impella_hlm_xclamp"
                      :options="yesno"
                      :disabled="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <template v-if="patientInfo.op_impella_hlm_xclamp === 'ja'">
                  <b-col cols="12" key="opimphlmxclampdauer">
                    <b-form-group
                      label="Xclamp Dauer [m]"
                      label-for="op_impella_hlm_xclamp_dauer"
                      label-cols-md="4"
                    >
                      <b-form-input
                        v-model="patientInfo.op_impella_hlm_xclamp_dauer"
                        id="op_impella_hlm_dauer"
                        type="number"
                        placeholder="Xclamp Dauer [m]"
                        :readonly="readOnly"
                      />
                    </b-form-group>
                  </b-col>
                </template>
              </template>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Grafts Anzahl"
                  label-for="op_impella_grafts_anzahl"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_grafts_anzahl"
                    id="op_impella_grafts_anzahl"
                    type="number"
                    placeholder="Grafts Anzahl"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <template v-if="patientInfo.op_impella_grafts_anzahl > 0">
                <b-col key="graftsart" cols="12">
                  <b-form-group
                    label="Grafts Art"
                    label-for="op_impella_grafts_art"
                    label-cols-md="4"
                  >
                    <v-select
                      v-model="patientInfo.op_impella_grafts_art"
                      :options="['LIMA', 'RIMA', 'A. rad', 'Vene']"
                      multiple
                      :close-on-select="false"
                      :disabled="readOnly"
                    />
                    <!-- TODO this fails to save -->
                  </b-form-group>
                </b-col>
              </template>
              <b-col cols="12">
                <b-form-group
                  label="Anastomosen Anzahl"
                  label-for="op_impella_anastomosen_anzahl"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_anastomosen_anzahl"
                    id="op_impella_anastomosen_anzahl"
                    type="number"
                    placeholder="Anastomosen Anzahl"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Hb [g/dl]"
                  label-for="op_impella_hb"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_hb"
                    id="op_impella_hb"
                    type="number"
                    placeholder="Hb [g/dl]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="pH"
                  label-for="op_impella_ph"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_ph"
                    id="op_impella_hb"
                    type="number"
                    placeholder="pH"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Transfusionen"
                  label-for="op_impella_transfusionen"
                  label-cols-md="4"
                >
                  <v-select
                    v-model="patientInfo.op_impella_transfusionen"
                    :options="yesno"
                    :disabled="readOnly"
                  />
                </b-form-group>
              </b-col>

              <template v-if="patientInfo.op_impella_transfusionen === 'ja'">
                <b-col cols="12" key="imptransek">
                  <b-form-group
                    label="EK Anzahl"
                    label-for="op_impella_transfusionen_ek_anzahl"
                    label-cols-md="4"
                  >
                    <b-form-input
                      v-model="patientInfo.op_impella_transfusionen_ek_anzahl"
                      id="op_impella_transfusionen_ek_anzahl"
                      type="number"
                      placeholder="EK Anzahl"
                      :readonly="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" key="imptransffp">
                  <b-form-group
                    label="FFP Anzahl"
                    label-for="op_impella_transfusionen_ffp_anzahl"
                    label-cols-md="4"
                  >
                    <b-form-input
                      v-model="patientInfo.op_impella_transfusionen_ffp_anzahl"
                      id="op_impella_transfusionen_ffp_anzahl"
                      type="number"
                      placeholder="FFP Anzahl"
                      :readonly="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" key="imptranstk">
                  <b-form-group
                    label="TK Anzahl"
                    label-for="op_impella_transfusionen_tk_anzahl"
                    label-cols-md="4"
                  >
                    <b-form-input
                      v-model="patientInfo.op_impella_transfusionen_tk_anzahl"
                      id="op_impella_transfusionen_tk_anzahl"
                      type="number"
                      placeholder="TK Anzahl"
                      :readonly="readOnly"
                    />
                  </b-form-group>
                </b-col>
              </template>
              <b-col cols="12">
                <b-form-group
                  label="Lasix"
                  label-for="op_impella_lasix"
                  label-cols-md="4"
                >
                  <v-select
                    v-model="patientInfo.op_impella_lasix"
                    :options="yesno"
                    :disabled="readOnly"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Diurese [ml]"
                  label-for="op_impella_diurese"
                  label-cols-md="4"
                >
                  <b-form-input
                    v-model="patientInfo.op_impella_diurese"
                    id="op_impella_diurese"
                    type="number"
                    placeholder="Diurese [ml]"
                    :readonly="readOnly"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card title="Komplikationen" class="op">
      <b-form @submit.prevent class="px-2">
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Komplikationen"
                  label-for="op_komplikationen"
                  label-cols-md="4"
                >
                  <v-select
                    v-model="patientInfo.op_komplikationen"
                    :options="yesno"
                    :disabled="readOnly"
                  />
                </b-form-group>
              </b-col>
              <template v-if="patientInfo.op_komplikationen === 'ja'">
                <b-col cols="12">
                  <b-form-group
                    label="Bypass Revision"
                    label-for="op_komplikationen_bypass_revision"
                    label-cols-md="4"
                  >
                    <v-select
                      v-model="patientInfo.op_komplikationen_bypass_revision"
                      :options="yesno"
                      :disabled="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="Blutung Impella"
                    label-for="op_komplikationen_blutung_impella"
                    label-cols-md="4"
                  >
                    <v-select
                      v-model="patientInfo.op_komplikationen_blutung_impella"
                      :options="yesno"
                      :disabled="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="Andere"
                    label-for="op_komplikationen_andere"
                    label-cols-md="4"
                  >
                    <v-select
                      v-model="patientInfo.op_komplikationen_andere"
                      :options="yesno"
                      :disabled="readOnly"
                    />
                  </b-form-group>
                </b-col>
                <template v-if="patientInfo.op_komplikationen_andere === 'ja'">
                  <b-col cols="12">
                    <b-form-group
                      label="Details anderer Komplikationen"
                      label-for="op_komplikationen_andere_detail"
                      label-cols-md="4"
                    >
                      <b-form-input
                        v-model="patientInfo.op_komplikationen_andere_detail"
                        id="op_komplikationen_andere_detail"
                        type="text"
                        placeholder=""
                        :readonly="readOnly"
                      />
                    </b-form-group>
                  </b-col>
                </template>
              </template>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { convertDate2Str, dateMask } from "@core/utils/utils";
import { mapState, mapActions } from "vuex";
import config from "@/config";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  timers: {
    updatePatient: config.TIMER_OPTION,
  },
  data() {
    return {
      patientInfo: {
        _id: null,
        op_tte_klappenstatus_mitralinsuff: "",
        op_tte_klappenstatus_mitralstenose: "",
        op_tte_klappenstatus_aorteninsuff: "",
        op_tte_klappenstatus_aortenstenose: "",
        op_tte_klappenstatus_trikuspidalklappeninsuff: "",
        op_tte_rechter_ventrikel_gemess_gradient_ueber_trikuspidalklappe: "",
        op_tte_rechter_ventrikel_tapse: "",
        op_impella_op_date: "",
        op_impella_op_dauer: "",
        op_impella_access_site: "",
        op_impella_hzv: "",
        op_impella_spap: "",
        op_impella_dpap: "",
        op_impella_hlm: "",
        op_impella_hlm_dauer: "",
        op_impella_hlm_xclamp: "",
        op_impella_hlm_xclamp_dauer: "",
        op_impella_grafts_anzahl: "",
        op_impella_grafts_art: [],
        op_impella_anastomosen_anzahl: "",
        op_impella_hb: "",
        op_impella_ph: "",
        op_impella_transfusionen: "",
        op_impella_transfusionen_ek_anzahl: "",
        op_impella_transfusionen_ffp_anzahl: "",
        op_impella_transfusionen_tk_anzahl: "",
        op_impella_lasix: "",
        op_impella_diurese: "",
        op_komplikationen: "",
        op_komplikationen_bypass_revision: "",
        op_komplikationen_blutung_impella: "",
        op_komplikationen_andere: "",
        op_komplikationen_andere_detail: "",
      },
      hospital: null,
      hospitals: [],
      yesno: ["ja", "nein"],
      nichterhoben: ["nicht erhoben"],
      jnnichterhoben: ["ja", "nein", "nicht erhoben"],
      birth: "",
      gender: "",
      date: null,
      date1: null,
    };
  },
  computed: {
    ...mapState("patient", ["patient", "role"]),
    readOnly() {
      return this.role == "viewer" || this.role == "";
    },
  },
  watch: {
    date(v, ov) {
      if (v) {
        this.patientInfo.op_impella_op_date = convertDate2Str(v);
      }
    },
    patient(v, ov) {
      if (v._id) {
        this.setPatientInfo(v);
      }
    },
  },
  mounted() {
    this.fetchHospitals();
    if (this.patient._id) {
      this.setPatientInfo(this.patient);
    }
  },
  // beforeDestroy() {
  //   this.updatePatient()
  // },
  methods: {
    dateMask,
    ...mapActions("patient", ["updatePatientById"]),
    updatePatient() {
      if (this.readOnly) {
        return;
      }

      let activeElement = document.activeElement;
      let blockingElements = ["input", "textarea"];

      // check whether an input field is the active elemnent,
      //if it is, do not interrupt the users entries with updating
      // the patientInfo but return instead
      if (
        activeElement &&
        blockingElements.indexOf(activeElement.tagName.toLowerCase()) !== -1
      ) {
        return;
      }

      this.updatePatientById(this.patientInfo).catch((err) => {
        this.showToast(
          "danger",
          "Error",
          "An error occured while updating the patient."
        );
      });
    },
    fetchHospitals() {
      this.$http
        .get("/hospitals/list_for_update")
        .then((res) => {
          this.hospitals = res.data.hospitals;
        })
        .catch((err) => {
          this.showToast(
            "danger",
            "Error",
            "An error occured while fetching hospitals."
          );
        });
    },
    handleSave() {
      this.$http
        .patch(`/patients/update/${this.$route.params.id}`, this.patientInfo)
        .then((res) => {
          this.showToast("success", "Success", "Successfully updated.");
        })
        .catch((err) => {
          this.showToast(
            "danger",
            "Error",
            "An error occured while saving the patient."
          );
        });
    },
    setPatientInfo(v) {
      this.patientInfo._id = v._id;

      this.patientInfo.op_tte_klappenstatus_mitralinsuff =
        v.op_tte_klappenstatus_mitralinsuff;
      this.patientInfo.op_tte_klappenstatus_mitralstenose =
        v.op_tte_klappenstatus_mitralstenose;
      this.patientInfo.op_tte_klappenstatus_aorteninsuff =
        v.op_tte_klappenstatus_aorteninsuff;
      this.patientInfo.op_tte_klappenstatus_aortenstenose =
        v.op_tte_klappenstatus_aortenstenose;
      this.patientInfo.op_tte_klappenstatus_trikuspidalklappeninsuff =
        v.op_tte_klappenstatus_trikuspidalklappeninsuff;
      this.patientInfo.op_tte_rechter_ventrikel_gemess_gradient_ueber_trikuspidalklappe =
        v.op_tte_rechter_ventrikel_gemess_gradient_ueber_trikuspidalklappe;
      this.patientInfo.op_tte_rechter_ventrikel_tapse =
        v.op_tte_rechter_ventrikel_tapse;
      this.patientInfo.op_impella_op_date = v.op_impella_op_date;
      this.patientInfo.op_impella_op_dauer = v.op_impella_op_dauer;
      this.patientInfo.op_impella_access_site = v.op_impella_access_site;
      this.patientInfo.op_impella_hzv = v.op_impella_hzv;
      this.patientInfo.op_impella_spap = v.op_impella_spap;
      this.patientInfo.op_impella_dpap = v.op_impella_dpap;
      this.patientInfo.op_impella_hlm = v.op_impella_hlm;
      this.patientInfo.op_impella_hlm_dauer = v.op_impella_hlm_dauer;
      this.patientInfo.op_impella_hlm_xclamp = v.op_impella_hlm_xclamp;
      this.patientInfo.op_impella_hlm_xclamp_dauer =
        v.op_impella_hlm_xclamp_dauer;
      this.patientInfo.op_impella_grafts_anzahl = v.op_impella_grafts_anzahl;
      this.patientInfo.op_impella_grafts_art = v.op_impella_grafts_art;
      this.patientInfo.op_impella_anastomosen_anzahl =
        v.op_impella_anastomosen_anzahl;
      this.patientInfo.op_impella_hb = v.op_impella_hb;
      this.patientInfo.op_impella_ph = v.op_impella_ph;
      this.patientInfo.op_impella_transfusionen = v.op_impella_transfusionen;
      this.patientInfo.op_impella_transfusionen_ek_anzahl =
        v.op_impella_transfusionen_ek_anzahl;
      this.patientInfo.op_impella_transfusionen_ffp_anzahl =
        v.op_impella_transfusionen_ffp_anzahl;
      this.patientInfo.op_impella_transfusionen_tk_anzahl =
        v.op_impella_transfusionen_tk_anzahl;
      this.patientInfo.op_impella_lasix = v.op_impella_lasix;
      this.patientInfo.op_impella_diurese = v.op_impella_diurese;
      this.patientInfo.op_komplikationen = v.op_komplikationen;
      this.patientInfo.op_komplikationen_bypass_revision =
        v.op_komplikationen_bypass_revision;
      this.patientInfo.op_komplikationen_blutung_impella =
        v.op_komplikationen_blutung_impella;
      this.patientInfo.op_komplikationen_andere = v.op_komplikationen_andere;
      this.patientInfo.op_komplikationen_andere_detail =
        v.op_komplikationen_andere_detail;
    },
    showToast(variant, title, content) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: "BellIcon",
          text: content,
          variant,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.op {
  .vertical-align {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .bordered-card {
    border: 1px solid rgba(34, 41, 47, 0.125);
  }
}
</style>
